// Note: 
// These properties are placed inside the oltb object in localStorage
// So the don't need to be prefixed with oltb
const LocalStorageKeys = Object.freeze({
    bookmarkTool: 'bookmarkTool',
    coordinatesTool: 'coordinatesTool',
    directionTool: 'directionTool',
    drawTool: 'drawTool',
    editTool: 'editTool',
    graticuleTool: 'graticuleTool',
    homeTool: 'homeTool',
    layerTool: 'layerTool',
    magnifyTool: 'magnifyTool',
    mapData: 'mapData',
    measureTool: 'measureTool',
    overviewTool: 'overviewTool',
    scaleLineTool: 'scalelineTool',
    scissorsTool: 'scissorsTool',
    settingsManager: 'settingsManager',
    splitViewTool: 'splitviewTool',
    themeTool: 'themeTool',
    toolboxTool: 'toolboxTool',
    translationManager: 'translationManager',
    zoomboxTool: 'zoomboxTool'
});

export { LocalStorageKeys };